/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Row,
    Col,
    Card,
    Button,
    Divider,
    Modal,
    Select,
    Checkbox,
    Input,
    DatePicker,
} from 'antd';
import moment from 'moment';
import CustomTimePicker from './CustomTimePicker';
import { CarryOutOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomSpin from '../CommonSpin';
import { Content } from 'antd/es/layout/layout';
import { useAuth } from '../../Context';
import { checkupPaymentsRequest } from './Actions';
import { selectAddPackageSuccessMsg, selectLoading } from './Selectors';
import { BodyTextKey, ButtonText, ModalHeading, TittleHeader } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { TextArea } = Input;

// To repeat the data
const RepeatData = ({ heading, value }) => (
    <div style={{ paddingRight: '30px', marginTop: '30px' }}>
        <b>{heading}</b>
        {value}
    </div>
);

const BookCheckup = () => {
    const [patientId, setPatientId] = useState(null);
    const [date, setDate] = useState(null);
    const [time, setTime] = useState(null);
    const [pincode, setPincode] = useState(null);
    const [address, setAddress] = useState(null);
    const [isParentAddress, setIsParentAddress] = useState(false);
    const [atMiciroclinic, setAtMiciroclinic] = useState(false);
    const [pincodeStatus, setPincodeStatus] = useState(false);
    
    const naviage = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();

    const successMsg = useSelector(selectAddPackageSuccessMsg);

    const { familyGet, familyDetails } = useAuth();
    
    const requesting = useSelector(selectLoading);
    const packageDetails = state.data;
    const patientDeatils = familyDetails;    

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    let gutcDateTime = new Date().toISOString();
    let gmomentUTCTime = moment.utc(gutcDateTime);
    let gfultime = gmomentUTCTime.add(5, 'hours').add(30, 'minutes');

    

    useEffect(() => {
    // on reload to back routing
        familyGet();
        window.addEventListener('load', onReload);
        // dispatch({ type: PATIENT_GET });

        return () => {
            window.removeEventListener('load', onReload);
        };
    }, [dispatch]);

    if(successMsg) {
        naviage('/mycheckups');
    }


    const onReload = () => {
        naviage('/allpackages');
    };
    
    const selectPatient = (value, key) => {
        if (key.key === 'true') {
            Modal.warning({
                title: 'Selected patient is an international citizen',
            });
        }
        setPatientId(value);
    };    
    
    const DateChange = (date, dateString) => {
        setDate(dateString);
        // Reset time when date changes
        setTime(null);
    };

    const parentAddressCheckbox = (e) => {
        setIsParentAddress(e.target.checked);
        setAddress('');
        setPincode('');
    };

    const atMiciroclinicCheckbox = (e) => {
        setAtMiciroclinic(e.target.checked);
        setIsParentAddress(e.target.checked);
        setAddress('');
        setPincode('');
    };

    const disabledDate = (current) => current <= moment().subtract(1, 'days').endOf('day');    const TimeChange = (value) => {
        if (!value) {
            setTime(null);
            return;
        }
        const [hour, minute, period] = value.split(':');
        const time24 = moment(`${hour}:${minute} ${period}`, 'h:mm A').format('HH:mm:ss');
        setTime(time24);
    };

    const onChangePincode = (e) => {
        const value = e.target.value;
        if (value.match(/^\d{6}$|^\d{6}-\d{4}$/)) {
            setPincodeStatus(false);
            setPincode(value);
        } else {
            setPincodeStatus(true);
            setPincode(null);
        }
    };

    const onChangeAddress = (e) => {
        setAddress(e.target.value);
    };

    const confirm = () => {
        let packages = packageDetails;
        
        if ((state.promotion == true ? packages.isPreferredSampleCollection : packages.organisation.isPreferredSampleCollection) === false) {
            setAddress('');
        }        

        if (patientId && date && time && pincode) {
            dispatch( checkupPaymentsRequest({data : {patientDetails: { patientId, date, time, address, pincode, isParentAddress, atMiciroclinic  }, packageDetails : {state}, total : total, promotion : state.promotion }}));
        } else {
            Modal.warning({
                title: 'Please enter all fields',
            });
        }
    };

    let total;
    let sampleCollectionFee;
    let Amount;
    if (packageDetails) {
        if ((state.promotion == true ? packageDetails.isPreferredSampleCollection : packageDetails.organisation.isPreferredSampleCollection)) {
            sampleCollectionFee = packageDetails && packageDetails.organisation &&  packageDetails.organisation.pickupCost;
        } else {
            sampleCollectionFee = 0;
        }

        Amount = packageDetails && packageDetails.isDiscounted ? packageDetails && packageDetails.discountPrice : packageDetails  && packageDetails.originalPrice;

        if (atMiciroclinic) {
            total = Amount;
            sampleCollectionFee = 0;
        } else {
            total = Amount + sampleCollectionFee;
        }
    }    

    const patientOptions = [];
    if (patientDeatils !== null) {
        patientDeatils && patientDeatils.map((item) => (
            patientOptions.push({
                value : item.id,
                label : `${item.firstName} ${item.lastName}`
            })
        ));
    }

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    return (
        <Content>
            <div>

                <Row type="flex" justify="center">
                    <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Col
                            xs={{ span: 24 }}
                            md={{ span: 24 }}
                            style={{
                                marginTop: '5px',
                                marginBottom: '15px',
                            }}
                        >
                            <Col
                                xs={{ span: 23 }}
                                md={{ span: 23 }}
                                lg={{ span: 23 }}
                                xl={{ span: 23 }}
                                xxl={{ span: 23 }}
                                style={{
                                    marginLeft: '2%',
                                    background: '#fff',
                                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                                    borderRadius: '4px',
                                }}
                            >
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 10 }} xl={{ span: 10 }} xxl={{ span: 10 }} style={{ textAlign: 'right' }}>
                                        <div
                                            style={{
                                                marginLeft: '1%',
                                                textAlign: 'left',
                                                fontFamily: 'Roboto',
                                                fontSize: '27px',
                                                color: '#1164A6',
                                                paddingLeft: '8px',
                                                margin : '10px',
                                                display: 'flex'
                                            }}
                                        >
                                            <CarryOutOutlined />                   
                                            <TittleHeader text = {`${langdata.BookCheckup ? langdata.BookCheckup : 'Book Checkup' }`} color='#1164A6'/>                  
                                        </div>
                                    </Col>                                
                                </Row>
                            </Col>
                        </Col>
                    </Col>
                </Row>

                
                <Row type="flex" justify="center">        
                    <Card
                        style={{
                            // marginTop: '10px',
                            boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                            borderRadius: '8px',
                            width: '900px',
                            marginBottom : '10px'
                        }}
                    >
                        <Col xl={{ span: 24 }}>
                            <Row>
                                <Col span={12}>
                                    <div style={{ fontWeight: 'bolder', fontSize: '20px' }}><ModalHeading text = {`${langdata.PackageDetailsC ? langdata.PackageDetailsC : 'Package Details :' }`} /></div>
                                    {packageDetails && (
                                        <div>
                                            <RepeatData heading={<BodyTextKey text = {`${langdata.PackageNameC ? langdata.PackageNameC : 'Package Name: ' }`} /> } value={state.promotion == true ? packageDetails.packageName :  packageDetails.name} />
                                            <RepeatData heading={<BodyTextKey text = {`${langdata.PackageDescriptionC ? langdata.PackageDescriptionC : 'Package Description: '  }`}/> } value={state.promotion == true ? packageDetails.packageDescription : packageDetails.description} />
                                            <RepeatData heading={<BodyTextKey text = {`${langdata.AmountC ? langdata.AmountC : 'Amount: '  }`}/> } value={`${Amount && Amount + packageDetails.discount}`} />
                                            {packageDetails.isDiscounted && <RepeatData heading={<BodyTextKey text = {`${langdata.DiscountC ? langdata.DiscountC : 'Discount: '  }`} />} value={`₹ ${packageDetails.discount}`} />}
                                            {packageDetails.isDiscounted && <RepeatData heading={<BodyTextKey text = {`${langdata.DiscountPercentageC ? langdata.DiscountPercentageC : 'Discount Percentage: ' }`} /> } value={`${packageDetails.discountPercentage} %`} />}
                                            {packageDetails.organisation && packageDetails.organisation.isPreferredSampleCollection && (
                                                <RepeatData heading={<BodyTextKey text = {`${langdata.SampleCollectionFeeC ? langdata.SampleCollectionFeeC : 'Sample Collection Fee: ' }`} /> } value={`₹ ${sampleCollectionFee}`} />
                                            )}
                                            <RepeatData heading={<BodyTextKey text = {`${langdata.TotalAmountC ? langdata.TotalAmountC : 'Total Amount: ' }`} /> } value={`₹ ${total}`} />
                                        </div>
                                    )}
                                </Col>

                                <Col span={1}>
                                    <Divider type="vertical" style={{ height: '500px' }} />
                                </Col>

                                {packageDetails && (
                                    <Col span={11}>
                                        <div style={{ paddingRight: '38px', marginTop: '40px' }}>
                                            <BodyTextKey text = {`${langdata.ChoosePatientC ? langdata.ChoosePatientC : 'Choose Patient :' }`} />{' '}
                                            <Select
                                                style={{ width: '250px' }}
                                                placeholder={`${langdata.Selectapatient ? langdata.Selectapatient : 'Select a patient' }`}
                                                onSelect={selectPatient}
                                                filterOption={filterOption}
                                                options={patientOptions}
                                                showSearch
                                            >
                                            </Select>
                                        </div>
                                        <div style={{ paddingRight: '30px', marginTop: '10px' }}>
                                            <BodyTextKey text = 'Date :' /> <br />
                                            <DatePicker
                                                style={{ width: '250px' }}
                                                onChange={DateChange}
                                                // format={'DD-MM-YYYY'}
                                                disabledDate={disabledDate}
                                            />
                                        </div>
                                        <div style={{ paddingRight: '30px', marginTop: '10px' }}>
                                            <BodyTextKey text = 'Time :' /> <br />
                                            <CustomTimePicker
                                                style={{ width: '250px' }}
                                                value={time ? moment(time, 'HH:mm:ss').format('h:mm:A') : null}
                                                onChange={TimeChange}
                                                selectedDate={date}
                                                hourLabel={langdata.Hour ? langdata.Hour : 'Hour'}
                                                minuteLabel={langdata.Minute ? langdata.Minute : 'Minute'}
                                                ampmLabel={langdata.AMPM ? langdata.AMPM : 'AM/PM'}
                                                defaultOpenValue={moment(`${gfultime.hour()}:${gfultime.minute()}`, 'HH:mm')}
                                            />
                                        </div>
                                        {packageDetails.organisation && packageDetails.organisation.isPreferredSampleCollection && (
                                            <div>
                                                <Checkbox style={{ marginTop: '20px' }} onChange={atMiciroclinicCheckbox}>
                                                    <BodyTextKey text = {`Collect sample at ${packageDetails.organisation.name}`} />
                                                </Checkbox>
                                            </div>
                                        )}
                                        {packageDetails.organisation && packageDetails.organisation.isPreferredSampleCollection && (
                                            <div style={{ marginTop: '20px' }}>
                                                <BodyTextKey text = {`${langdata.SampleCollectionaddressC ? langdata.SampleCollectionaddressC : 'Sample Collection address : ' }`} /><br />
                                                <Checkbox style={{ marginTop: '20px' }} disabled={atMiciroclinic} onChange={parentAddressCheckbox}>
                                                    <BodyTextKey text = {`${langdata.Sameaspatientaddress ? langdata.Sameaspatientaddress : 'Same as patient address' }`} />
                                                </Checkbox>
                                                <div style={{ marginTop: '20px' }}>
                                                    <TextArea
                                                        disabled={isParentAddress}
                                                        onChange={onChangeAddress}
                                                        placeholder="Address"
                                                        style={{ width: '250px' }}
                                                        rows={4}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div style={{ paddingRight: '30px', marginTop: '10px' }}>
                                            <BodyTextKey text = 'Pincode :' /><br />
                                            <Input
                                                style={{ width: '250px' }}
                                                disabled={isParentAddress}
                                                onChange={onChangePincode}
                                                placeholder="Pincode"
                                            />
                                            {pincodeStatus && <div style={{ color: 'red' }}>{`${langdata.Pleaseenteravalidpincode ? langdata.Pleaseenteravalidpincode : 'Please enter a valid pincode' }`}</div>}
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </Col>

                        <Col md={{ span: 24 }} style={{ textAlign: 'right' }}>
                            <Button
                                onClick={() => {
                                    naviage(-1);
                                }}
                            >
                                <ButtonText text  = {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`} color='black' />
                            </Button>
                            <Button
                                style={{ marginLeft: '8px', marginTop: '35px' }}
                                type="primary"
                                onClick={confirm}
                            >
                                <ButtonText text  = {`${langdata.Confirm ? langdata.Confirm : 'Confirm' }`} />
                            </Button>
                        </Col>
                    </Card>
                </Row>
                <CustomSpin spinning = {requesting} />
            </div>
        </Content>
    );
};


export default BookCheckup;